export class UnauthenticatedError extends Error {
  constructor() {
    super('You are not authenticated.')
  }
}
